/**
 * Created by mac on 2/25/20
 */

const FogTile = function (x, y, fogBlock, options) { 
    this.x = x;
    this.y = y;
    this.openDelay = 0;
    this.isHead = options && options.head;
    this.fogBlock = fogBlock;
    this.fake = options && options.fake;
    this.state = fogBlock.state;
    this.borders = [];

    Map2d.currentMap.add(Map2d.LAYER_FOG, this.x, this.y, this);
    if (Map2d.currentMap.isVisibleCell(x, y)) {
        Map2d.currentMap.onAdd(Map2d.LAYER_FOG, x, y, this);
    }
};

FogTile.prototype.clear = function () {
    this.removeView();
};

FogTile.prototype.onOpenFogBlock = function () {
    if (this.view) {
        this.view.onOpenFogBlock();
    }
};

FogTile.prototype.setView = function (view) {
    this.view = view;
    if (this.onViewCreated) {
        this.onViewCreated(view);
        delete this.onViewCreated;
    }
};

FogTile.prototype.removeView = function () {
    this.view = undefined;
};

FogTile.prototype.onGetView = function () {
    return this.view;
};

FogTile.prototype.onOpen = function (callback, silent) {
    callback = callback || function () {};
    if (this.view) {
        this.view.onOpen(callback, silent);
    } else {
        callback();
    }
};

FogTile.prototype.onUpdateState = function (state, silent) {
    if (this.view) {
        this.view.onUpdateState(state, silent);
    }
};

FogTile.prototype.onClick = function () {
    if (this.view) {
        this.view.onClick();
    }
};

FogTile.prototype.checkTouchInside = function (touch) {
    if (this.view) {
        return this.view.checkTouchInside(touch);
    }
};

FogTile.prototype.pointOfInterestsSqueeze = function () {
    if (this.view) {
        this.view.pointOfInterestsSqueeze();
    }
};

FogTile.prototype.onDestructFog = function () {
    if (this.view) {
        this.view.destructFog();
    }
};

FogTile.prototype.touchFilter = function () {
    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive()) {
        return !Map2dLocation.currentLocation.tutorial.checkConditions({ fog: this.fogBlock.id });
    }

    if (cleverapps.tutorial.isActive()) {
        return !cleverapps.tutorial.checkConditions({ fog: this.fogBlock.id });
    }

    return false;
};

FogTile.prototype.onClickEvent = function (touch) {
    if (this.fogBlock) {
        let pointOfInterestUnit = undefined;
        const pointOfInterestTile = this.checkPointOfInterestTouchInside(touch);
        if (pointOfInterestTile) {
            pointOfInterestUnit = this.getFakeUnit();
            pointOfInterestUnit = pointOfInterestUnit.head || pointOfInterestUnit;
        }
        if (pointOfInterestTile) {
            pointOfInterestTile.pointOfInterestsSqueeze();
        }
        this.fogBlock.click(pointOfInterestUnit);
    }
};

FogTile.prototype.getFogType = function () {
    const type = Map2d.currentMap.getTerrainType(this.x, this.y);
    return (bundles[type.name] || bundles[type.defaultTiles]).meta.fog;
};

FogTile.prototype.getFogKey = function () {
    const bundle = this.getFogBundle();
    return bundle ? bundle.name.replace("fogs_", "") : "";
};

FogTile.prototype.getFogBundle = function () {
    const type = Map2d.currentMap.getTerrainType(this.x, this.y);
    const meta = (bundles[type.name] || bundles[type.defaultTiles]).meta;
    const code = type.code || type.defaultTerrain;
    const baseBundle = bundles[`fogs_${meta.fog}_${code}`] || bundles[`fogs_${meta.fog}`];
    if (FogDecorations.enabled) {
        return bundles[`fogs_${meta.fog}_${code}_imprv`] || baseBundle;
    }
    return baseBundle;
};

FogTile.prototype.getOpenDelay = function () {
    return this.openDelay;
};

FogTile.prototype.getOpenDuration = function () {
    const styles = cleverapps.styles.FogTileView[this.getFogType()];

    return styles && styles.whirlwind && styles.whirlwind.duration
        || styles && styles.dispelling && styles.dispelling.duration
        || (styles && styles.groundStateOnly ? 0 : 500);
};

FogTile.prototype.checkPointOfInterestTouchInside = function (touch) {
    if (this.isPointOfInterest()) {
        const fakeUnit = this.getFakeUnit();

        let fogTile = this;
        if (fakeUnit.head) {
            fogTile = Map2d.currentMap.getFog(fakeUnit.head.x, fakeUnit.head.y);
        }
        if (fogTile && fogTile.checkTouchInside(touch)) {
            return fogTile;
        }
    }
    return false;
};

FogTile.prototype.getFakeUnit = function () {
    return Map2d.currentMap.fogs.getFakeUnit(this.x, this.y);
};

FogTile.prototype.updateState = function (state, silent) {
    this.state = state;
    this.onUpdateState(state, silent);

    if (this.balloon) {
        this.balloon.updateState(state, silent);
    }
};

FogTile.prototype.open = function () {
    Map2d.currentMap.remove(Map2d.LAYER_FOG, this.x, this.y);

    this.fogBlock.remove(this.x, this.y);
    this.fogBlock = undefined;

    const fakeUnits = Map2d.currentMap.fogs.getFakeUnits(this.x, this.y).filter((u) => !u.head);
    const units = [];
    fakeUnits.forEach((fakeUnit, index) => {
        const unit = new Unit(fakeUnit);
        if (unit.findComponent(Multiple)) {
            unit.findComponent(Multiple).init(index, fakeUnits.length);
        }
        unit.setPosition(this.x, this.y);
        units.push(unit);
    });
    if (units.length > 0) {
        Map2d.currentMap.add(Map2d.LAYER_UNITS, this.x, this.y, units.length === 1 ? units[0] : units);
    }
};

FogTile.prototype.animateOpen = function (silent, callback) {
    Map2d.currentMap.animateFogTileOpen(this, silent, callback);
};

FogTile.prototype.isPointOfInterest = function () {
    const fakeUnit = this.getFakeUnit();
    if (!fakeUnit) {
        return false;
    }

    if (this.fogBlock && this.fogBlock.options.debugMode === true && !cleverapps.config.debugMode) {
        return false;
    }

    return fakeUnit.pointOfInterest || (fakeUnit.head && fakeUnit.head.pointOfInterest);
};

FogTile.prototype.addBalloon = function (balloon) {
    this.balloon = balloon;
};

FogTile.prototype.removeBalloon = function () {
    delete this.balloon;
};

FogTile.prototype.fromBlockedGround = function () {
    return this.fogBlock && this.fogBlock.id === "blockedGroundFog";
};

FogTile.prototype.getBorders = function () {
    this.fogBlock.calcTilesBorders();
    return this.borders;
};